// removed by extract-text-webpack-plugin
module.exports = {"btn_name":"btn-solid,btn-ghost","btn_size":"small,medium,large,wide"};